/* eslint-disable func-names */
/* eslint-disable import/no-extraneous-dependencies */
import { rest } from 'msw';
import { mockServerApi } from '@/common/utils';
import { authRequests, companiesRequests, creativesRequests, usersRequests, assetsRequests, assetEditorRequests, assetMocksRequests, gamesRequests } from './requests';
import { PRODUCTS_LIST, PLAY_PARTNER_LIST, CANVAS_PARTNER_LIST } from './data';

export default [
  ...authRequests(rest),
  ...usersRequests(rest),
  ...companiesRequests(rest),
  ...creativesRequests(rest),
  ...assetsRequests(rest),
  ...assetEditorRequests(rest),
  ...gamesRequests(rest),

  rest.get(mockServerApi('/types/products'), (_req, res, ctx) => res(
    ctx.status(200),
    ctx.json({
      items: PRODUCTS_LIST,
    }),
  )),

  rest.get(mockServerApi('/types/partners/play'), (_req, res, ctx) => res(
    ctx.status(200),
    ctx.json({
      items: PLAY_PARTNER_LIST,
    }),
  )),

  rest.get(mockServerApi('/types/partners/canvas'), (_req, res, ctx) => res(
    ctx.status(200),
    ctx.json({
      items: CANVAS_PARTNER_LIST,
    }),
  )),

  ...assetMocksRequests(rest),
];
